<template>
<!-- 首页扩展视频轮播 -->
  <div class="expend-video-box">
    <div class="expend-video-con" >
      <div class="video">
        <video :src="videoSrc" muted="" autoplay="true" id="expendVideo"></video>
        <div class="controller">
          <div>
            <div class="progress" >
              <div class="hotspot">
                <div class="dot" @click="playVideo('formular')"></div>
                <div class="popover" :class="{'active': activeVideo === 'formular'}">
                  <div class="popover-frame" style="margin-left: -56px;">公式编辑</div>
                </div>
              </div>
              <div class="title" :class="{'display': activeVideo !== 'formular'}" @click="playVideo('formular')" style="margin-left: -26px;">公式编辑</div>
              <div class="line">
                <div :class="{'transition': activeVideo === 'formular' && !isClick}" :style="{width: expend1Width}"></div>
              </div>
            </div>
            <div class="progress" >
              <div class="hotspot">
                <div class="dot" @click="playVideo('frontCode')"></div>
                <div class="popover" :class="{'active': activeVideo === 'frontCode'}">
                  <div class="popover-frame" style="margin-left: -65px;">前端代码块</div>
                </div>
              </div>
              <div class="title" :class="{'display': activeVideo !== 'frontCode'}" @click="playVideo('frontCode')" style="margin-left: -35px;">前端代码块</div>
              <div class="line">
                <div :class="{'transition': activeVideo === 'frontCode' && !isClick}" :style="{width: expend2Width}"></div>
              </div>
            </div>
            <div class="progress" >
              <div class="hotspot">
                <div class="dot" @click="playVideo('external')"></div>
                <div class="popover" :class="{'active': activeVideo === 'external'}">
                  <div class="popover-frame" style="margin-left: -72px;">外部资源注册</div>
                </div>
              </div>
              <div class="title" :class="{'display': activeVideo !== 'external'}" @click="playVideo('external')" style="margin-left: -44px;">外部资源注册</div>
              <div class="line">
                <div :class="{'transition': activeVideo === 'external' && !isClick}" :style="{width: expend3Width}"></div>
              </div>
            </div>
            <div class="progress" >
              <div class="hotspot">
                <div class="dot" @click="playVideo('codeAnalysis')"></div>
                <div class="popover" :class="{'active': activeVideo === 'codeAnalysis'}">
                  <div class="popover-frame" style="margin-left: -65px;">代码全解析</div>
                </div>
              </div>
              <div class="title" :class="{'display': activeVideo !== 'codeAnalysis'}" @click="playVideo('codeAnalysis')" style="margin-left: -35px;">代码全解析</div>
              <div class="line">
                <div :class="{'transition': activeVideo === 'codeAnalysis' && !isClick}" :style="{width: expend4Width}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const expend1 = require('../assets/video/expend1.mp4');
const expend2 = require('../assets/video/expend2.mp4');
const expend3 = require('../assets/video/expend3.mp4');
const expend4 = require('../assets/video/expend4.mp4');

export default {
  name: "ExpendSwiper",
  data() {
    return {
      videoSrc: expend1,
      activeVideo: 'formular',
      expend1Width: '0%', // 视频1的播放进度
      expend2Width: '0%',
      expend3Width: '0%',
      expend4Width: '0%',
      timer: '',
      isClick: false,
    };
  },
  methods: {
    playVideo(flag) {
      const self = this;
      self.isClick = true;
      if (flag === 'formular') {
        self.videoSrc = expend1;
        self.activeVideo = 'formular';
        self.expend1Width = '0';
        self.expend2Width = '0';
        self.expend3Width = '0';
        self.expend4Width = '0';
      } else if (flag === 'frontCode') {
        self.videoSrc = expend2;
        self.activeVideo = 'frontCode';
        self.expend1Width = '100%';
        self.expend2Width = '0';
        self.expend3Width = '0';
        self.expend4Width = '0';
      } else if (flag === 'external') {
        self.videoSrc = expend3;
        self.activeVideo = 'external';
        self.expend1Width = '100%';
        self.expend2Width = '100%';
        self.expend3Width = '0';
        self.expend4Width = '0';
      } else if (flag === 'codeAnalysis') {
        self.videoSrc = expend4;
        self.activeVideo = 'codeAnalysis';
        self.expend1Width = '100%';
        self.expend2Width = '100%';
        self.expend3Width = '100%';
        self.expend4Width = '0';
      }
    },
  },
  mounted() {
    const self = this;
    const elevideo = document.getElementById("expendVideo");
    let duration = 0; // 视频总长度
    elevideo.addEventListener('loadedmetadata', () => {
      //视频的总长度
      // console.log('总长度:' + elevideo.duration);
      duration = elevideo.duration;
      clearInterval(this.timer);
    });
    // 监听播放中的视频 展示进度条
    elevideo.addEventListener('playing', () => {
      self.isClick = false;
      this.timer = setInterval(() => {
        // console.log('播放进度:' + parseFloat(elevideo.currentTime));
        const process = elevideo.currentTime;
        if (duration) {
          let percentage = parseFloat(process/duration); // 百分比
          if (self.videoSrc === expend1) {
            self.expend1Width = Math.ceil(percentage * 100) + '%';
          } else if (self.videoSrc === expend2) {
            self.expend2Width = Math.ceil(percentage * 100) + '%';
          } else if (self.videoSrc === expend3) {
            self.expend3Width = Math.ceil(percentage * 100) + '%';
          } else if (self.videoSrc === expend4) {
            self.expend4Width = Math.ceil(percentage * 100) + '%';
          }
        }
      }, 100);
    });
    // 监听视频播放结束 修改视频路径
    elevideo.addEventListener('ended', () => {
      clearInterval(this.timer);
      let path = '';
      let active = '';
      if (self.videoSrc === expend1) {
        path = expend2;
        active = 'frontCode';
      } else if (self.videoSrc === expend2) {
        path = expend3;
        active = 'external';
      } else if (self.videoSrc === expend3) {
        path = expend4;
        active = 'codeAnalysis';
      } else if (self.videoSrc === expend4) {
        path = expend1;
        active = 'formular';
        self.expend1Width = '0';
        self.expend2Width = '0';
        self.expend3Width = '0';
        self.expend4Width = '0';
      }
      self.videoSrc = path;
      self.activeVideo = active;
    }, false);
  },
};
</script>

<style>
.expend-video-box, .expend-video-con {height: 100%;overflow: hidden;border-radius: 10px;}
.video {
  position: relative;
  max-width: 1200px;
  min-width: 920px;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #aabbd2;
}
.video video {width: 100%;height: 100%;}
.video .controller {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 90px;
  background: linear-gradient(180deg, rgba(255,255,255,0.07) 0%, #FFFFFF 100%);
}
.video .controller>div {display: flex;width: 100%;padding: 0 75px;}
.progress {flex: 1;position: relative;bottom: 55px;}
.progress .hotspot {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 20px;
  cursor: pointer
}
.progress .hotspot .dot {
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 10px;
  background-color: #1D79FB;
}
.progress .hotspot .popover {
  position: absolute;
  top: 24px;
  left: 10px;
  z-index: -1;
  height: 32px;
  transform: scale(0);
  transition: transform .3s;
}
.progress .hotspot .popover-frame {
  background: #1D79FB;
  padding: 0 20px;
  border-radius: 16px;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
  color: #FFF;
  transition: all .3s ease;
}
.progress .hotspot .popover.active {transform: scale(1);}
.progress .title {
  display: none;
  position: absolute;
  top: 24px;
  left: 0px;
  z-index: -1;
  width: auto;
  font-size: 18px;
  font-weight: bold;
  transition: all .3s ease;
  cursor: pointer;
}
.title.display {display: block;}
.progress .line {
  position: absolute;
  top: 8px;
  z-index: -1;
  width: 100%;
  height: 4px;
  background-color: rgba(148, 148, 148, 0.3)
}
.progress .line>div {height: 4px;background-color: #1D79FB;}
.progress .line>div.transition {
  transition-property: width;
  transition-duration: .5s;
  transition-timing-function: linear
}
.progress:last-child .line {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  overflow: hidden
}

</style>



// WEBPACK FOOTER //
// src/components/ExpendSwiper.vue